import { AxiosResponse } from "axios";
import { AliasViewModel } from "../aliases/AliasStore";
import { MatchParticipantViewModel } from "../matches/MatchesStore";
import axios, { APIWrapperResponse, DefaultResponse } from "../general/HttpClient";

export function getTeams(organizationID, includeArchived = false) {
    return axios.get("/api/Teams/getTeams", { params: { organizationID, includeArchived } }).then((response: AxiosResponse<APIWrapperResponse<Array<TeamViewModel>>>) => {
        return response.data.result;
    });
}

export function getAliasTeams(id, includeArchived = false) {
    return axios.get(`/api/Teams/getAliasTeams/${id}`, { params: { includeArchived } }).then((response: AxiosResponse<APIWrapperResponse<Array<TeamViewModel>>>) => {
        return response.data.result;
    });
}

export function getTeam(id) {
    return axios.get(`/api/Teams/getTeam/${id}`).then((response: AxiosResponse<APIWrapperResponse<TeamViewModel>>) => {
        return response;
    });
}

export function createTeam(request: CreateTeamRequest) {
    return axios.post(`/api/Teams/createTeam`, request).then((response: AxiosResponse<APIWrapperResponse<CreateTeamResponse>>) => {
        return response.data.result;
    });
}

export function updateTeam(request: UpdateTeamRequest | TeamViewModel) {
    return axios.put(`/api/Teams/updateTeam`, request).then((response: AxiosResponse<APIWrapperResponse<CreateTeamResponse>>) => {
        return response.data.result;
    });
}

export function getTeamMembers(id) {
    return axios.get(`/api/Teams/getTeamMembers/${id}`).then((response: AxiosResponse<APIWrapperResponse<Array<TeamMembershipViewModel>>>) => {
        return response;
    });
}

export function createTeamMember(request: CreateTeamMemberRequest) {
    return axios.post(`/api/Teams/createTeamMember`, request).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}
export function removeTeamMember(request: RemoveTeamMemberRequest) {
    return axios.post(`/api/Teams/removeTeamMember`, request).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export function searchTeams(query = "", organizationID = "", skip = 0, limit = 200, includeArchived = false) {
    return axios.get("/api/Teams/searchTeams", { params: { query, organizationID, skip, limit, includeArchived } }).then((response: AxiosResponse<APIWrapperResponse<Array<TeamViewModel>>>) => {
        return response.data.result;
    });
}

export interface TeamViewModel {
    id: string;
    organizationID: string;
    name: string;
    logoUri: string;
    splashUri: string;
    about: string;
    countryCode: string;
    color: string;
    created: string;
    rating: number;
    isPublic: boolean;
    teamMemberships: TeamMembershipViewModel[];

    matchesPlayed: number;
    matchesWon: number;

    archived: boolean;
}

export interface TeamMembershipViewModel {
    id: string;
    roleName: string;
    teamID: string;
    team: TeamViewModel;
    aliasID: string;
    alias: AliasViewModel;
    created: string;
    updated: string;
}

export interface CreateTeamRequest {
    organizationID: string;
    name: string;
    logoUri: string;
    logoContent: string;
    splashUri: string;
    splashContent: string;
    about: string;
    countryCode: string;
    color: string;
    isPublic: boolean;
    archived: boolean;
}

export interface CreateTeamMemberRequest {
    roleName: string;
    teamID: string;
    aliasID: string;
}

export interface CreateTeamResponse {
    success: boolean;
    teamID: string;
    errors: string[];
}

export interface RemoveTeamMemberRequest {
    teamID: string;
    aliasID: string;
}

export interface UpdateTeamRequest {
    organizationID: string;
    id: string;
    name: string;
    logoUri: string;
    logoContent?: string;
    splashUri: string;
    splashContent?: string;
    about: string;
    countryCode: string;
    color: string;
    isPublic: boolean;
    archived: boolean;
}
